import type { FAQItem, ResourcePageSeo } from "../resource-seo";

export const faqs: FAQItem[] = [
  {
    question: "Are MindMyJob career guides free?",
    answer:
      "Yes. Every guide is free to read, with no account needed. Sign up only if you want to use the MindMyJob tools the guides link to.",
  },
  {
    question: "What topics do the guides cover?",
    answer:
      "Resumes and ATS, interview preparation for behavioural, technical and case rounds, salary negotiation, and running an efficient job search.",
  },
  {
    question: "How do I make my resume ATS-friendly?",
    answer:
      "Use a single-column layout, standard section titles such as Experience and Skills, plain-text skills instead of graphics, and the exact keywords from the job description. Our ATS guide walks through each rule with before-and-after examples.",
  },
  {
    question: "What is the STAR method?",
    answer:
      "STAR stands for Situation, Task, Action and Result. It is a way to structure answers to behavioural questions so you give a specific example, explain what you did and show the outcome. The interview guides include sample STAR answers by role.",
  },
  {
    question: "How should I answer the expected salary question?",
    answer:
      "Give the market range for the role and city rather than your current pay, then ask whether it fits their budget. The negotiation guides include word-for-word scripts for this and for countering an offer.",
  },
  {
    question: "Can I practise what I learn?",
    answer:
      "Yes. Each guide links to the matching tool: the Smart Resume Builder and JobFit Scorer for resumes, AI Mock Interview for interview answers, and Salary Insights for negotiation.",
  },
  {
    question: "How often are the guides updated?",
    answer:
      "We review guides regularly and update them when hiring practices change, for example when common ATS platforms change how they parse resumes.",
  },
];

export const seo: ResourcePageSeo = {
  slug: "career-guides",
  name: "Career Guides",
  title: "Free Career Guides: Resumes, Interviews, Salary | MindMyJob",
  description:
    "Free guides on ATS-friendly resumes, interview answers with the STAR method and salary negotiation scripts, with real examples you can use today.",
  keywords: [
    "career guides",
    "ats friendly resume guide",
    "resume writing tips",
    "interview preparation guide",
    "star method examples",
    "behavioural interview questions",
    "salary negotiation scripts",
    "how to counter a job offer",
    "job search advice",
    "resume before and after examples",
  ],
  ogImage: "/assets/images/resources/career-guides/hero-resume-guides.png",
  ogImageAlt:
    "MindMyJob career guides library with resume, interview and negotiation guides",
  featureList: [
    "Resume and ATS guides with before-and-after examples",
    "Interview question banks by role and round",
    "STAR method sample answers",
    "Salary negotiation scripts",
    "Counteroffer email templates",
    "Checklists at the end of every guide",
  ],
  faqs,
};
